import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCollapseModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import {
  ButtonComponent,
  LoaderComponent,
  ModalComponent,
  ModalFooterDirective,
  StatusComponent,
  TableCellDirective,
  TableGridComponent
} from 'mbs-ui-kit';
import { AsyncResultsModalComponent } from './async-results-modal.component';

@UntilDestroy()
@Component({
  selector: 'mbs-computers-async-results-modal',
  templateUrl: './async-results-modal.component.html',
  styleUrls: ['./async-results-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbCollapseModule,
    NgbTooltipModule,
    LoaderComponent,
    StatusComponent,
    ButtonComponent,
    ModalComponent,
    TableGridComponent,
    I18NextPipe,
    ModalFooterDirective,
    TableCellDirective
  ]
})
export class ComputersAsyncResultsModalComponent extends AsyncResultsModalComponent {
  protected i18nPipe = inject(I18NextPipe);

  protected subTitle: Signal<string> = computed(() => {
    const compText = this.i18nPipe.transform('shared:computers.computer', { format: 'title', count: this.data()?.resultList.length || 0 });

    return `${compText}: ${this.data()?.resultList.length}/${this.data()?.total}`;
  });
}
